import { Button } from "primereact/button";
import { ConfirmPopup, confirmPopup } from "primereact/confirmpopup";
import { Dialog } from "primereact/dialog";

const EnrollmentPromptModal = ({
  visible,
  onHide,
  onEnroll,
  pathName,
  isLoading,
  currentLevel,
  title,
}) => {
  const handleEnrollClick = event => {
    if (currentLevel) {
      confirmPopup({
        target: event.currentTarget,
        message: `Enrolling in ${title} will pause your enrollment in ${currentLevel.role.name} in the ${currentLevel.name} Level. Would you like to continue?`,
        icon: "pi pi-exclamation-triangle",
        acceptLabel: "Yes",
        rejectLabel: "No",
        accept: () => onEnroll(true),
        style: { maxWidth: "400px" },
      });
    } else {
      onEnroll();
    }
  };

  const footer = (
    <div className="flex justify-end gap-2">
      <Button label="Cancel" severity="secondary" outlined onClick={onHide} disabled={isLoading} />
      <Button label="Enroll" onClick={handleEnrollClick} loading={isLoading} />
    </div>
  );

  return (
    <Dialog
      header="Enroll in Path?"
      visible={visible}
      onHide={onHide}
      footer={footer}
      style={{ width: "450px" }}
      modal
      closable={!isLoading}
      draggable={false}
    >
      <p className="body-regular">
        You have started a lesson that is part of the <strong>{pathName}</strong> path. To complete
        this path and receive a certificate, please enroll.
      </p>
      <ConfirmPopup />
    </Dialog>
  );
};

export default EnrollmentPromptModal;
